import { publicRequest, request } from '@/utils/request';

// 根据id查询商品详情
export function examSkillQuestion(params) {
  const { token, examSkillIds } = params; // 解构出 token 和 examSkillIds
    return request({
      url: `/structuralExam/examSkillQuestion/getByIds`,
      method: 'get',
      params: { examSkillIds }, // 将 examSkillIds 作为查询参数
      headers: {
        Authorization: `Bearer ${token}` // 使用Bearer token格式
      }
    })
  }

// 根据设备号查询候考大屏
export function getStationScreen(params) {
  return request({
    url: `/structuralExam/examStation/getStationScreen`,
    method: 'get',
    params
  })
}

// 获取本机ip
export function getIp() {
  return request({
    url: `/structuralExam/examDevice/getIp`,
    method: 'get',
  })
}
// headers: {
      //   'Authorization': `Bearer ${'eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjozNjIzOCwidXNlcl9pZCI6NDM0MzAsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI0ODg1YmQ3NS0xY2E4LTQ3ZWItYTA4YS0wZTE5ZWQ0ZjgyZWUiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzc5NzA5MDc5NCJ9.mrK-1nWGw3mGb6AN3l0EYH3vbBjLcS1jPj70HJTg66A38Zd9mJ21sZIyrTl9sry264atORXUZLxtfJBImGVAMA'}`, // 添加 token 到请求头
      // },


// 查询当前房间的题目
export function getSkillInfo(params) {
  return request({
    url: `/structuralExam/examDevice/getSkillInfo`,
    method: 'get',
    params
  })
}

// 查询设备当前状态
export function getDeviceInfo(codedAddress) {
  return request({
    url: `/structuralExam/examDevice/getDeviceInfo/${codedAddress}`,
    method: 'get',
  })
}
